query SessionIssueTypes($runId: ConditionID!) {
	wfa_session_type_runs(run_id_eq: $runId) {
		type_id
		type_name
		severity_name
		severity_id
		total_issues
	}
}
